import { useDisplayMode } from 'conversations-visitor-experience-components/contexts/DisplayModeContext';
import { DOCKED } from 'conversations-internal-schema/widget-data/constants/widgetDisplayModeTypes';
import WidgetWrapper from './WidgetWrapper';
import SideDockWidgetWrapper from '../side-dock/components/SideDockWidgetWrapper';
import { jsx as _jsx } from "react/jsx-runtime";
const WidgetWrapperSelector = ({
  isOpen,
  mobile,
  inline,
  widgetLocation,
  children
}) => {
  const {
    widgetDisplayMode
  } = useDisplayMode();
  if (widgetDisplayMode === DOCKED) {
    return /*#__PURE__*/_jsx(SideDockWidgetWrapper, {
      isOpen: isOpen,
      widgetLocation: widgetLocation,
      children: children
    });
  }
  return /*#__PURE__*/_jsx(WidgetWrapper, {
    isOpen: isOpen,
    mobile: mobile,
    inline: inline,
    widgetLocation: widgetLocation,
    children: children
  });
};
WidgetWrapperSelector.displayName = 'WidgetWrapperSelector';
export default WidgetWrapperSelector;